import { MdOutlineCancel } from 'react-icons/md'
import ATTextButton from '../../../common/formComponent/ATTextButton'
import ATRadioButton from '../../../common/radioButton/ATRadioButton'
import { useAddUserRolesHooks } from '../../../../customHooks/usermanagement/useAddUserRolesHooks'
import {
  ApplicationTypesData,
  appSelectedTypesData,
} from '../../../../interface/response/UserRolesResponse'
import { useAddUpdateUserHooks } from '../../../../customHooks/usermanagement/useAddUpdateUserHooks'

interface AddUserRolesProps {
  backButtonHandler: () => void
  continueButtonHandler: () => void
  onCloseModal: () => void
  getRoleList: ApplicationTypesData[]
  isEdit: boolean
  userId?: string
}

const AddUserRoles = ({
  backButtonHandler,
  continueButtonHandler,
  onCloseModal,
  getRoleList,
  isEdit,
  userId,
}: AddUserRolesProps) => {
  const {
    selectedData,
    selectedAppCode,
    appRoles,
    handleAppSelection,
    handleRoleSelection,
    checkedRoles,
    removeSelectedRole,
    isCustomerSelected,
    localSelectedData,
    t,
  } = useAddUserRolesHooks(getRoleList)
  const { addUserDetails, updateUserDetails } = useAddUpdateUserHooks(
    selectedData,
    userId,
    onCloseModal,
  )
  return (
    <div>
      <div className="d-flex justify-content-between p-4 mx-4 user-details-container">
        <div>
          <p className="user-header">{t('userRoles.user_name')}</p>
          <p className="user-data">{selectedData?.userInfo?.userName}</p>
        </div>
        <div>
          <p className="user-header">{t('userRoles.user_phone')}</p>
          <p className="user-data">{selectedData?.userInfo?.phone}</p>
        </div>
        <div>
          <p className="user-header">{t('userRoles.user_email')}</p>
          <p className="user-data">{selectedData?.userInfo?.email}</p>
        </div>
      </div>
      <div className="d-flex justify-content-between p-4">
        <div
          className="roleBorder col-4 scroll-list-content"
          style={{ height: '355px', overflow: 'auto' }}
        >
          {getRoleList?.map((app: ApplicationTypesData) => {
            return (
              <div
                role="button"
                className={`border-bottom ps-3 py-1 pointer list-hauler-style ${
                  app?.applicationCode === selectedAppCode &&
                  'selected-back-ground'
                } `}
                key={app?.applicationCode}
                onClick={() => {
                  handleAppSelection(app?.applicationCode)
                }}
              >
                <div className="appList">{app?.name.toUpperCase()}</div>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="labelSubContent">{checkedRoles(app)}</div>
                  <div
                    className={`${checkedRoles(app) ? 'visible' : 'invisible'}`}
                  >
                    <button
                      title={t('common.clear')}
                      className="btn btn-link link-button me-2"
                      aria-label="Clear"
                      onClick={() => {
                        removeSelectedRole(app?.applicationCode)
                      }}
                    >
                      <MdOutlineCancel size={17} />
                    </button>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        <div
          className="roleBorder col-8 scroll-list-content "
          style={{ height: '355px', overflow: 'auto' }}
        >
          {appRoles?.map((role) => {
            return (
              <div
                className="border-bottom ps-3 py-1 list-hauler-style"
                key={role?.roleCode}
              >
                <ATRadioButton
                  id={role?.roleCode}
                  label={role?.roleName}
                  name="roles"
                  subContent={role?.description ? role?.description : <></>}
                  handleChange={(e) => handleRoleSelection(role?.roleCode)}
                  checked={localSelectedData.some(
                    (item: appSelectedTypesData) =>
                      item.roleCode === role?.roleCode,
                  )}
                  selectedValue={role?.roleCode}
                />
              </div>
            )
          })}
        </div>
      </div>
      <div className="d-flex px-4 pb-4 justify-content-end">
        <div>
          <ATTextButton
            title={t('common.cancel')}
            onPressHandler={() => onCloseModal()}
            isFilledButton={false}
          />
        </div>
        <div>
          <ATTextButton
            title={t('common.back')}
            onPressHandler={() => {
              backButtonHandler()
            }}
            disabled={false}
          />
        </div>
        <div>
          {isCustomerSelected() ? (
            <ATTextButton
              title={t('common.continue')}
              onPressHandler={() => {
                continueButtonHandler()
              }}
              disabled={false}
            />
          ) : (
            <ATTextButton
              title={isEdit ? t('common.update') : t('common.save')}
              onPressHandler={
                isEdit
                  ? () => {
                      updateUserDetails()
                    }
                  : () => {
                      addUserDetails()
                    }
              }
              disabled={localSelectedData.length < 1}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default AddUserRoles
